import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { AiChatActions } from '@qtek/libs/store';
import { SubWebsocketMessageRequest } from '@qtek/core/websockets-core';

type SubscribeChatEventsPayload = Omit<
  SubWebsocketMessageRequest,
  'ent' | 'op'
>;

@Injectable({ providedIn: 'root' })
export class AiChatEventSubscriptionService {
  private store = inject(Store);

  private readonly refCounts = new Map<string, number>();

  acquire(chatId: string, payload: SubscribeChatEventsPayload): void {
    const next = (this.refCounts.get(chatId) ?? 0) + 1;
    this.refCounts.set(chatId, next);
    if (next === 1) {
      this.store.dispatch(AiChatActions.subscribeChatEvents({ payload }));
    }
  }

  release(chatId: string): void {
    const next = (this.refCounts.get(chatId) ?? 0) - 1;
    if (next <= 0) {
      this.refCounts.delete(chatId);
      this.store.dispatch(
        AiChatActions.unsubscribeChatEvents({ mysid: `chatEvent_${chatId}` })
      );
      return;
    }
    this.refCounts.set(chatId, next);
  }
}
